module.exports = __webpack_public_path__ + "static/no-risk-b09fbb2762803bf122203ce2dd681072.svg";